import { comment } from '@axo/shared/data-access/types';
import { send } from '../../lib/send';
import { IAPI } from '../../lib/models/api';

export function find({ url: { service: baseURL }, token }: IAPI) {
  return async function find(
    marketCountry: string
  ): Promise<comment.CommentTemplates> {
    return send({
      baseURL,
      token,
      path: `/comment-template?marketCountry=${marketCountry}`,
      method: 'GET',
    });
  };
}
